import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {property} from 'lit/decorators/property.js';

import store from '../store';

import {
	selectBasicSpcAttributes,
	selectBasicSpcAttributesSatisfactionPercentage,
	selectBasicSpcAttributesSatisfied,
	selectDetailSpcAttributes,
	selectDetailSpcAttributesSatisfactionPercentage, selectFilteredSpcAttributes,
	selectFirstSection,
	selectProductData, selectSpcAttributes, selectSpcComponents, selectSpcConfiguration, selectSpcConfigurations,
	selectSpcIsSatisfied,
	selectUnfilteredBasicSpcAttributes,
	selectUnfilteredDetailSpcAttributes,
	selectUnFilteredSpcAttributes,
	selectUnsatisfiedSpcAttributes
} from '../selectors';
import {stringToAttributeId} from './spc/util/spcUtils';
import {setDownloadPanelSpecsheetActive} from '../slices/statusSlice';
import {conditional} from '../util/conditional';
import {pimText, pimTextDebug} from '../util/values';

@customElement('components-view')
export class ComponentsView extends connect(store)(LitElement) {

	static styles = css`
		:host {
			height: 100%;
			padding: 0;
		}

		@media (max-width: 768px) {
			:host {
				padding: 0 var(--small-padding);
			}
		}

		:host::-webkit-scrollbar {
			display: none;
		}

		.header {
			font: var(--font-widget-label);
			color: var(--color-grey4);
			padding-bottom: var(--very-small-padding);
			margin-bottom: var(--padding);
			border-bottom: 1px solid var(--color-white);
			break-inside: avoid;
			break-after: avoid;
			position: relative;

		}

		.components {
			width: 100vw;
			height: 100%;
			padding: var(--large-padding);
			box-sizing: border-box;
		}
		.components.grid {
			display: grid;
			grid-auto-flow: row dense;
			gap: var(--features-column-gap, 48px);
			grid-template-columns: repeat(auto-fit, minmax(var(--features-column-width), 1fr));
		}
		.component {
			position: relative;
			break-inside: avoid;
		}



		.attributes {
			width: 100vw;
			height: 100%;
			padding: var(--large-padding);
			box-sizing: border-box;
		}

		.attributes.grid {
			display: grid;
			grid-auto-flow: row dense;
			gap: var(--features-column-gap, 48px);
			grid-template-columns: repeat(auto-fit, minmax(var(--features-column-width), 1fr));
		}

		.attribute {
			position: relative;
			break-inside: avoid;
		}


		.widget {
			position: relative;
			break-inside: avoid;
		}
		.widget>* {
			margin-bottom: var(--large-padding);
			display: block;
		}

		.progressButton {
			display: none;
		}

		@media (max-width: 768px) {
			.progressButton {
				display: block;
				padding-bottom: var(--features-column-gap);
			}
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.section = selectFirstSection(state);
		this.debugShowAll = state.status.debugShowAll;
		this.productData = selectProductData(state);

		this.region = state.status.region;
		this.lang = state.status.lang;
		this.spcIsSatisfied = selectSpcIsSatisfied(state);
		this.spcConfiguration = selectSpcConfiguration(state);
		this.conditionalVariantValues = state.productData.conditionalVariantValues;

		this.spcComponents = selectSpcComponents(state);
		this.spcComponents = this.spcComponents?.filter(component => component.id.componentPath === undefined || component.id.componentPath.length === 0)
			.sort((a, b) => a.key.localeCompare(b.key));

		this.spcAttributes = selectSpcAttributes(state);

		// console.log('ComponentsView', this.spcComponents, this.spcAttributes);

		this.filteredSpcAttributes = this.spcAttributes?.filter(attribute => attribute.id.componentPath === undefined || attribute.id.componentPath.length === 0)
			.filter(spcAttribute => spcAttribute.type === 'Choice')
			.filter(spcAttribute => Array.from(spcAttribute.values.values()).some(v => !v.isPossibleDecisionStatesImmutable))
			.sort((a, b) => a.key.localeCompare(b.key));

		//console.log('this.filteredSpcAttributes', this.filteredSpcAttributes);

	}
	c(id) {
		return conditional(this.spcConfiguration, this.conditionalVariantValues, id);
	}
	t(featureId, context, value, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, featureId, context, this.spcConfiguration, this.state.productData.translations, value, prefix, suffix) :
			pimText(this.lang, featureId, context, this.spcConfiguration, this.state.productData.translations, value, prefix, suffix);
	}

	connectedCallback() {
		super.connectedCallback();
	}

	render() {
		if (!this.spcComponents || !this.spcAttributes) return null;
		const zindex = 100;
		return html`
			<div class="attributes grid" id="attributesReference">
				${when(this.filteredSpcAttributes?.length > 0, () => html`
					${repeat(this.filteredSpcAttributes,
						(spcAttribute) => spcAttribute.key,
						// 'colorSelect','compactSelect', 'comboSelect', 'reducedSelect', 'reducedChoiceSelect'
						(spcAttribute, index) => html`
							<div class="attribute" style="z-index: ${zindex - (2 + index)}">
								<spc-attribute
									.attribute=${spcAttribute}
									.hideDisabledValues=${this.section.attributeOptions?.[spcAttribute.key]?.hideDisabledValues}
									.displayStyle=${'simpleSelect'}
									.addon=${this.section.attributeOptions?.[spcAttribute.key]?.addon}>
								</spc-attribute>
							</div>
						`
					)}
				`)}
			</div>
			<div class="components" id="componentsReference">
				${when(this.spcComponents?.length > 0, () => html`
					${repeat(this.spcComponents,
						(component) => component.key,
						(component, index) => html`
							<div class="component">
								<spc-component-attribute .attribute=${component}></spc-component-attribute>
							</div>
						`
					)}
				`)}
			</div>
		`;
	}
}
